import script from "./Homogenization.vue?vue&type=script&setup=true&lang=ts"
export * from "./Homogenization.vue?vue&type=script&setup=true&lang=ts"

import "./Homogenization.vue?vue&type=style&index=0&id=49fd15c6&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49fd15c6"]])

export default __exports__